module.exports = __webpack_public_path__ + "static/img/icon-mly.fe11471.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon-mly.png
// module id = VEkO
// module chunks = 0